// DS: i1.16
import React from 'react';
import IconWrap from '../../IconWrap';
const Lightning = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M11.36 2.5a.498.498 0 0 0-.431.25L5.567 12.1a.5.5 0 0 0 .432.75h5.655l-3.713 7.937a.5.5 0 0 0 .45.713h.315c.204 0 .398-.09.53-.247l9.144-10.795a.5.5 0 0 0-.379-.824h-4.01l-.296-.356 3.431-6.03a.5.5 0 0 0-.432-.748H11.36Z"
    })));
};
Lightning.displayName = 'Lightning';
export default Lightning;

//# sourceMappingURL=Lightning.js.map